import styled from 'styled-components';
import { blueDark01, blueLink } from '../../../../../../styles/colors';

export const NotificationContainer = styled.div`
    margin-left: 40px;
`;

export const CriteriaGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 24px;
    row-gap: 12px;
    margin-bottom: 8px;
`;

export const CriteriaGroup = styled.div`
    min-width: 0;
    margin-bottom: 4px;
`;

export const CriteriaName = styled.div`
    font-family: 'Proxima N W15 Bold';
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    color: ${blueDark01};
    margin-bottom: 2px;
`;

export const CriteriaValue = styled.div`
    display: block;
    font-size: 13px;
    line-height: 18px;
    color: ${blueLink};
    word-break: break-word;
`;

export const BannerWrapper = styled.div`
    min-height: 48px;
    background: #ffd788;
`;

export const BannerContainer = styled.div`
    padding: 16px 100px;
    position: relative;
`;

export const BannerToggleTrigger = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    height: 20px;
    gap: 12px;

    /* Switcher's circle is absolutely positioned inside a 50px box; shrink the box to the circle so the gap is the visible gap. */
    .switch-mesh {
        width: 24px;

        .switch-container {
            margin-left: 12px;
        }
    }
`;

export const BoltIcon = styled.img`
    font-size: 16px;
`;

export const BannerTitle = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-family: 'Proxima N W15 Bold';
    font-size: 14px;
    font-weight: 400;
    color: ${blueDark01};
`;

export const BannerCloseButton = styled.button`
    position: absolute;
    top: 12px;
    right: 16px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    color: ${blueDark01};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    &:hover {
        background: rgba(0, 0, 0, 0.08);
    }
`;

export const BannerSubtext = styled.p`
    font-size: 13px;
    color: ${blueDark01};
    margin: 8px 0 8px 0;

    a {
        color: ${blueLink};
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    }
`;

export const ProductsGrid = styled.div`
    column-count: 3;
    column-gap: 24px;
    margin-bottom: 8px;
`;

export const MfrGroup = styled.div`
    break-inside: avoid;
    margin-bottom: 12px;
`;

export const MfrName = styled.div`
    font-family: 'Proxima N W15 Bold';
    font-size: 13px;
    font-weight: 400;
    color: ${blueDark01};
    margin-bottom: 2px;
`;

export const ProductLink = styled.a`
    display: block;
    font-size: 13px;
    color: ${blueLink};
    text-decoration: none;
    line-height: 18px;
    &:hover {
        color: ${blueLink};
        text-decoration: underline;
    }
`;

export const SectionLabel = styled.div<{isFirst?: boolean}>`
    font-family: 'Proxima N W15 Bold';
    font-size: 13px;
    font-weight: 400;
    color: ${blueDark01};
    margin: ${({isFirst}) => (isFirst ? '0px' : '24px')} 0 2px 0;
`;

export const NoneText = styled.div`
    font-size: 13px;
    color: ${blueDark01};
`;
